import React from "react";
import './PageFooter.scss'

export default function PageFooter() {
    return (
        <div className="PageFooter">
            <div className="contact-us">
                <span style={{color:'white'}}>
                    上海市致远人工智能研究院 © All Rights Reserved
                </span>
                <a href="http://beian.miit.gov.cn/">沪ICP备18032283号-3</a>
                <span>徐汇校区：宜山路520号中华门大厦18楼1801室</span>
                <span>虹口校区：花园路66弄嘉和国际大厦西座3楼311室</span>
                <span>浦东校区：浦东新区金高路1296弄151号</span>
                <span>联系电话（姜老师）：15026920017</span>
            </div>
        </div>
    )
}
